import React, { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { api } from './api';

interface CompanyContextValue {
  companyLogo: string | null;
  companyLogoDark: string | null;
  companyName: string;
}

interface CompanyResponse {
  company_logo?: string;
  company_logo_dark?: string;
  company_name?: string;
}

const CompanyContext = createContext<CompanyContextValue | null>(null);

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }: { children: ReactNode }) => {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyLogoDark, setCompanyLogoDark] = useState(null);
  const [companyName, setCompanyName] = useState('Stock Manager');

  useEffect(() => {
    api.get<CompanyResponse | CompanyResponse[]>('/companies/api/companies/')
      .then(response => {
        const data = Array.isArray(response) ? response[0] : response;
        if (data) {
          if (data.company_logo) {
            setCompanyLogo(data.company_logo.replace(/^https?:/, window.location.protocol));
          }
          if (data.company_logo_dark) {
            setCompanyLogoDark(data.company_logo_dark.replace(/^https?:/, window.location.protocol));
          }
          if (data.company_name) {
            setCompanyName(data.company_name);
          }
        }
      })
      .catch(() => {
        // Silently fall back to defaults
      });
  }, []);

  return (
    <CompanyContext.Provider value={{ companyLogo, companyLogoDark, companyName }}>
      {children}
    </CompanyContext.Provider>
  );
};
